<template>
  <div :class="[{ 'landing-page': isLandingPage() === true }]">
    <Authorization-header v-if="!getIsLoggedIn || isCompanyLandingPage()" />
    <app-header v-if="getIsLoggedIn && !isCompanyLandingPage()" />
    <conf-popup />
    <div class="wrapper">
      <div class="clearfix"></div>
      <inform-msg />
      <router-view />
    </div>
    <app-footer/>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import AuthorizationHeader from '@/components/main/common/AuthorizationHeader'
import AppHeader from '@/components/common/AppHeader'
import AppFooter from '@/components/main/common/AppFooter'
import ConfPopup from '@/components/common/ConfPopup'
import InformMsg from '@/components/common/InfomMsg'

export default {
  name: 'admin',
  computed: {
    ...mapGetters([
      'getIsLoggedIn',
      'getConfData'
    ])
  },
  methods: {
    ...mapActions([
      'setFontSizeActive',
      'setColorPaletteActive'
    ]),
    isLandingPage () {
      let route = this.$route.name
      let response = false
      let landings = [
        'about',
        'edit-about',
        'login',
        'edit-login',
        'home',
        'edit-homepage',
        'download-brochure',
        'edit-download-brochure',
        'contact',
        'edit-contact',
        'ask-experts',
        'edit-ask-expert',
        'terms-and-conditions',
        'edit-terms-and-conditions',
        'privacy-policy',
        'edit-privacy-policy',
        'accessibility-section',
        'edit-accessibility-section',
        'cookies',
        'edit-cookies',
        'company-landing'
      ]
      if (landings.indexOf(route) > -1) {
        response = true
      }
      return response
    },
    isCompanyLandingPage () {
      let route = this.$route.name
      let response = false
      if (route === 'company-landing') {
        response = true
      }
      return response
    }
  },
  components: {
    AuthorizationHeader,
    AppHeader,
    AppFooter,
    ConfPopup,
    InformMsg
  },
  mounted () {
    this.setFontSizeActive()
    this.setColorPaletteActive()
  }
}
</script>



// WEBPACK FOOTER //
// Home.vue?1803da7e